/**
 * Created by natalia.petrov on 8/1/2017.
 */
import C from  '../constants/news';
import { getAjaxRequest} from '../utils/helpers';

export function getNews() {
    let url ='api/v1/news';
    return getAjaxRequest(url,C.GET_NEWS);
}
export function updateNewsContext(payload){
    return (dispatch) => {
       return dispatch({
            type: C.UPDATE_NEWS_CONTEXT,
            payload: payload
        });
    }
}



// WEBPACK FOOTER //
// ./actions/news.js